"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          GState.bind(this, [
              "tenant",
              "theme",
              "banner"
            ]);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/AuthBackground.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_BackgroundImage = require("public/images/backgrounds/bg-grey.png"),
    BackgroundImage = module_BackgroundImage.default || module_BackgroundImage,
    marko_styleValue = require("marko/dist/runtime/helpers/style-value");

function render(input, out, __component, component, state) {
  var data = input;

  out.e("div", {
      style: marko_styleValue({
          opacity: (((!state.tenant) || (!state.banner)) && state.theme) && (state.theme.mode == "light") ? "1" : "0.1",
          "background-image": ("url(\"" + (state.banner || BackgroundImage)) + "\")",
          "background-size": "cover"
        }),
      "class": "position-fixed vw-100 vh-100"
    }, "0", component, 0, 1);
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
